import { List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core'
import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
} from '@material-ui/icons'

import { CategorySub } from './Category'

interface Props {
  path: string[]
  categories: CategorySub[]
  onNextClick: (id: string) => void
  onSelect: (c: null | CategorySub) => void
}

export function CategoryList({ path, categories, onNextClick, onSelect }: Props) {
  return (
    <List<any> component="div" disablePadding>
      {path.length > 0 ? (
        <ListItem divider button onClick={() => onNextClick('')}>
          <ListItemIcon>
            <ChevronLeftIcon color="secondary" />
          </ListItemIcon>
          <ListItemText primary="TOPメニューに戻る" />
        </ListItem>
      ) : (
        <ListItem divider button onClick={() => onSelect(null)}>
          <ListItemText primary="全てのカテゴリー" />
        </ListItem>
      )}

      {categories.map(c => (
        <ListItem<any>
          divider
          button
          component="div"
          key={`${c.id}`}
          onClick={() => {
            if (!c.sub || !c.sub.length) {
              return onSelect(c)
            }
            onNextClick(`${c.id}`)
          }}
        >
          <ListItemText primary={c.title} />
          {c.sub?.length ? <ChevronRightIcon color="secondary" /> : null}
        </ListItem>
      ))}
    </List>
  )
}
